import { IPackage } from "dto/IPackage";
import { create } from "zustand";

export const useThreadStore = create((set) => ({
  messages: {} as Record<string, IPackage[]>,
  setMessages: (threadId: string, newState: IPackage[]) => {
    set((state: Record<string, IPackage[]>) => {
      const old = state;
      old[threadId] = newState;

      return { messages: old };
    });
  },
}));
